<template>
    <div class="table-action-btn" title="Загрузка документов">     
        <svg width="16" height="16" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M118 78.1606V112.911C118 115.668 115.757 117.911 113 117.911H15C12.243 117.911 10 115.668 10 112.911V78.1606H0V112.911C0 121.182 6.729 127.911 15 127.911H113C121.271 127.911 128 121.182 128 112.911V78.1606H118Z" fill="black"/>
<path d="M64 0.0898438L32.929 31.1608L40 38.2318L59 19.2318V97.1609H69V19.2318L88 38.2318L95.071 31.1608L64 0.0898438Z" fill="black"/>
</svg>

    </div>
</template>

<script>

export default {
    name: 'Btn_upload',

}

</script>

<style>
    .table-action-btn {
        display: inline-block;
         cursor: pointer;
         margin-left: 15px;
    }
</style>